import { Route, Routes } from "react-router-dom"


import ListarPendientes from "./ListarPendientes"


const CanjesRoutes = () => (
    <Routes>
        <Route path="/" Component={ListarPendientes} />
    </Routes>
)

export default CanjesRoutes